export default __webpack_public_path__ + "static/media/green-plant.2f171215.jpg";